import { ACTIONS, IAppActionInitData } from "app/store/actions"
import { IDspState } from "dsp/model"
import { Action, Reducer } from "redux"
import { getDefaultDspState } from "./state"

export const dspReducer: Reducer<IDspState, Action> = (state: IDspState | undefined, action: Action): IDspState => {
  if (!state) {
    state = getDefaultDspState()
  }
  switch (action.type) {
    case ACTIONS.APP_INIT_DATA: {
      const { dsps } = action as IAppActionInitData
      return {
        ...state,
        dsps
      }
    }

    case ACTIONS.USER_LOGOUT: {
      return getDefaultDspState()
    }

    default:
      return state
  }
}
